import { PanelType } from '../../../../../../panels/types';
import { CriteriaPanelData } from '../../base-criteria-plugin-panel/ConnectedBaseCriteriaPanel';

export const bantPanelType: PanelType<CriteriaPanelData> = {
  name: 'BANT_PANEL',
  location: 'left'
};
